import { Component, OnInit, AfterViewInit, ViewChildren, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControlName } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/operator/debounceTime';
import { AuthService } from "../../auth.service";
import { AppCommonService } from "../../appcommon.service";
import { GlobalService } from "../../global.service";
import { HeaderAndNavigationService } from '../headerandnavigation.service';
import { ILoggedUser } from '../loggeduser/loggeduser';
import { ForgottenPassword } from '../forgottenpassword/forgottenpassword';
import { GenericValidator } from '../../shared/generic-validator';
import { Observable } from 'rxjs/Observable';
import { ResetPassword } from './resetpassword';
import { LoaderService } from '../../LoaderService';
declare var $: any;

@Component({
  templateUrl: './resetpassword.component.html'
})
export class ResetPasswordComponent implements OnInit, AfterViewInit {
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
  resetPasswordForm: FormGroup;
  resetPassword: ResetPassword = new ResetPassword();
  displayMessageResetPassword: { [key: string]: string } = {};
  private validationMessagesResetPassword: { [key: string]: { [key: string]: string } };
  private genericValidatorResetPassword: GenericValidator;
  public pageTitle: string = 'Reset Password';  
  public loading = false;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private appCommonService: AppCommonService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public globalService: GlobalService,
    public headerAndNavigationService: HeaderAndNavigationService,
    public loaderService: LoaderService
  ) {
    this.validationMessagesResetPassword = {
      newPassword: {
        required: 'Password is required.'
      }
    };
    this.genericValidatorResetPassword = new GenericValidator(this.validationMessagesResetPassword);
  }

  ngOnInit(): void {
    this.appCommonService.pageContentAdditionalClass = "home-page login-page";

    // subscribe to router event
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let userId = params['userId'];
      let token = params['token'];
      let decodedtoken = decodeURI(token);
     
      //console.log(decodedtoken);
      this.resetPassword.userId = userId;
      this.resetPassword.token = decodedtoken;// token;
    });

    this.resetPasswordForm = this.fb.group({
      newPassword: ['', [Validators.required]]
    });
  }  

  newPasswordSubmit(): void {
    this.globalService.msgs = [];
    if (this.resetPasswordForm.dirty && this.resetPasswordForm.valid) {
      // Copy the form values over the product object values
      let p = Object.assign({}, this.resetPassword, this.resetPasswordForm.value);      
      this.loaderService.display(true);
      this.headerAndNavigationService.newUserPassword(p)
        .subscribe(
        () => {          
          this.loaderService.display(false);
          $('#redirectLoginModal').modal('show');
          this.onResetPasswordComplete();          
        },
        (error: any) => {
          this.loaderService.display(false);
          this.globalService.showError("Password", <any>error, true);          
        }
        );
    } else if (!this.resetPasswordForm.dirty) {
      this.onResetPasswordComplete();
    }
  }

  onResetPasswordComplete(): void {
    // Reset the form to clear the flags
    this.resetPasswordForm.reset();
  }

  redirectLogin() {    
    $('#redirectLoginModal').modal('hide');
    this.router.navigate(['/login']);
  }

  ngAfterViewInit() {
    this.appCommonService.loadRequiredJS();
    // Watch for the blur event from any input element on the form.
    let controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));

    // Merge the blur event observable with the valueChanges observable
    Observable.merge(this.resetPasswordForm.valueChanges, ...controlBlurs).debounceTime(500).subscribe(value => {
      this.displayMessageResetPassword = this.genericValidatorResetPassword.processMessages(this.resetPasswordForm);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/resetpassword/resetpassword.component.ts